import styles from './contact.module.scss';

import React from 'react';
import { Container } from 'reactstrap';

import ContactForm from 'src/components/ContactForm';

const ContactUs = (props) => (
  <Container styleName='contact-us'>
      <div styleName='text-container'>
          <div className='h1'>Drop us a line</div>
          <div className='h2 text-blue'>We&rsquo;d love to hear from you.</div>
      </div>
      <ContactForm />
      <div styleName='bg-square-1' />
      <div styleName='bg-square-2' />
  </Container>
);

export default ContactUs;



// WEBPACK FOOTER //
// ./src/pages/contact.js